import { useNavigate } from "react-router-dom";
import DoctorImage from "./DoctorImage";

const HomeHeroSection = (props) => {
  const navigate = useNavigate();
  const showReservation = props.isReservationPageEnabled !== false;
  const showConsultation = props.isConsultationPageEnabled !== false;
  const showBlog = props.isBlogPageEnabled !== false;
  const hasHeroActions = showReservation || showConsultation || showBlog;

  return (
    <section className="hero-section iran-sans">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-7 order-2 order-lg-1 px-3 ps-lg-5">
            <div className="hero-content">
              {/* Professional Badge */}
              <div className="professional-badge mb-3 d-none d-lg-inline-flex">
                <span className="badge-icon">⚕</span>
                <span className="badge-text pe-2">{props.HeroTitle}</span>
              </div>

              {/* Main Title */}
              <h1 className="hero-title mb-3 iran-sans">
                <span className="fw-bold">{props.DoctorName}</span>
              </h1>

              {props.DoctorSpecialty && (
                <div className="hero-specialty-wrap d-lg-none">
                  <span className="hero-specialty">
                    <span className="hero-specialty-dot" aria-hidden="true" />
                    <span>{props.DoctorSpecialty}</span>
                  </span>
                </div>
              )}

              {/* Subtitle */}
              <p
                className="hero-subtitle text-center text-lg-end mb-4 "
                style={{ textAlign: "justify" }}
                dangerouslySetInnerHTML={{
                  __html: props.HeroSubtitle.replace(/\n/g, "<br/>"),
                }}
              />
              {hasHeroActions && (
                <div className="hero-actions mb-4">
                  {showReservation && (
                    <button
                      className="hero-btn btn-primary"
                      onClick={() => navigate("/reservation/reserve")}
                    >
                      رزرو نوبت
                    </button>
                  )}
                  {showConsultation && (
                    <button
                      className={`hero-btn ${
                        showReservation ? "btn-secondary" : "btn-primary"
                      }`}
                      onClick={() => navigate("/counseling/index")}
                    >
                      مشاوره آنلاین
                    </button>
                  )}
                  {showBlog && (
                    <button
                      className={`hero-btn ${
                        showReservation || showConsultation
                          ? "btn-outline"
                          : "btn-primary"
                      }`}
                      onClick={() => navigate("/blog/index")}
                    >
                      مشاهده مقالات
                    </button>
                  )}
                </div>
              )}

              {/* Quick Stats */}
              <div className="quick-stats me-lg-4">
                {props.ShowYearExprience && (
                  <div className="stat-item">
                    <span className="stat-number">+ {props.YearExprience}</span>
                    <span className="stat-label">سال تجربه</span>
                  </div>
                )}

                {props.ShowYearExprience &&
                  (props.ShowPatientCount ||
                    props.ShowOnlineCounselingCount) && (
                    <div className="stat-divider">|</div>
                  )}

                {props.ShowPatientCount && (
                  <div className="stat-item">
                    <span className="stat-number">+ {props.PatientCount}</span>
                    <span className="stat-label">بیمار</span>
                  </div>
                )}

                {props.ShowPatientCount && props.ShowOnlineCounselingCount && (
                  <div className="stat-divider">|</div>
                )}

                {props.ShowOnlineCounselingCount && (
                  <div className="stat-item">
                    <span className="stat-number">
                      + {props.ConsultationCount}
                    </span>
                    <span className="stat-label">مشاوره آنلاین</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-5 order-1 order-lg-2 m-0 p-0">
            <div className="hero-image-section">
              <div className="image-container mt-2 ">
                <DoctorImage
                  width="100%"
                  height="100%"
                  scr={props.HeroImage}
                  alt={props.DoctorName}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .hero-section {
          background: linear-gradient(135deg, #053251 0%, #064a73 100%);
          color: white;
          padding: 4rem 0;
          margin-bottom: 0;
          min-height: auto;
        }

        .hero-content {
          padding: 1rem 0;
        }

        .professional-badge {
          display: inline-flex;
          align-items: center;
          background: rgba(124, 200, 144, 0.15);
          border: 1px solid #7cc890;
          border-radius: 6px;
          padding: 0.5rem 1rem;
          font-size: 0.85rem;
          font-weight: 500;
        }

        .badge-icon {
          font-size: 1rem;
          color: #7cc890;
        }

        .badge-text {
          color: #7cc890;
        }

        .hero-title {
          font-size: 2.8rem;
          font-weight: 600;
          line-height: 1.2;
          margin: 0;
          letter-spacing: -0.01em;
        }

        .hero-specialty-wrap {
          display: flex;
          justify-content: center;
          margin: -0.15rem auto 0.8rem;
        }

        .hero-specialty {
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          max-width: 100%;
          padding: 0.35rem 0.8rem;
          border: 1px solid rgba(124, 200, 144, 0.5);
          border-radius: 999px;
          color: #d8f4df;
          background: rgba(124, 200, 144, 0.12);
          font-size: 0.82rem;
          font-weight: 500;
          line-height: 1.6;
        }

        .hero-specialty-dot {
          width: 7px;
          height: 7px;
          flex: 0 0 7px;
          border-radius: 50%;
          background: #7cc890;
          box-shadow: 0 0 0 3px rgba(124, 200, 144, 0.12);
        }

        .hero-subtitle {
          font-size: 1rem;
          line-height: 1.5;
          opacity: 0.9;
          font-weight: 300;
          max-width: 480px;
          text-align: "justify";
        }

        .hero-actions {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-start;
          gap: 0.75rem;
          width: 100%;
        }

        .hero-btn {
          padding: 0.7rem 1.6rem;
          border: 1px solid transparent;
          border-radius: 6px;
          font-weight: 500;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-family: inherit;
          min-width: 150px;
          margin: 0;
          letter-spacing: 0;
        }

        .btn-primary {
          background-color: #7cc890;
          color: #053251;
        }

        .btn-primary:hover {
          background-color: #6bb77d;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(124, 200, 144, 0.3);
        }

        .btn-secondary {
          background-color: transparent;
          color: #7cc890;
          border: 1px solid #7cc890;
        }

        .btn-secondary:hover {
          background-color: rgba(124, 200, 144, 0.1);
          transform: translateY(-1px);
        }

        .btn-outline {
          background-color: transparent;
          color: white;
          border: 1px solid rgba(255, 255, 255, 0.4);
        }

        .btn-outline:hover {
          background-color: rgba(255, 255, 255, 0.1);
          border-color: rgba(255, 255, 255, 0.6);
        }

        .quick-stats {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding-top: 1.5rem;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
        }

        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .stat-number {
          font-size: 1.3rem;
          font-weight: 600;
          color: #7cc890;
          line-height: 1;
        }

        .stat-label {
          font-size: 0.8rem;
          opacity: 0.8;
          margin-top: 0.2rem;
        }

        .stat-divider {
          color: rgba(255, 255, 255, 0.3);
          font-size: 1.2rem;
        }

        .hero-image-section {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1rem;
        }

        .image-container {
          width: 400px;
          height: 400px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
          background: #064a73;
          transition:
            transform 0.5s ease-in-out,
            box-shadow 0.5s ease-in-out;
          margin-left: auto;
          margin-right: auto;
        }

        .image-container:hover {
          transform: scale(1.04);
          box-shadow: 0 12px 36px rgba(0, 0, 0, 0.3);
        }

        /* Tablet View */
        @media (max-width: 991.98px) {
          .hero-section {
            padding: 2.5rem 0;
          }

          .hero-title {
            font-size: 2rem;
            text-align: center;
            margin-right: 0;
            margin-left: 0;
          }

          .hero-subtitle {
            text-align: center !important;
            margin: 0 auto 1.5rem;
            font-size: 0.95rem;
          }

          .hero-actions {
            justify-content: center;
            margin: 0 auto 1.5rem;
          }

          .hero-content {
            text-align: center;
            padding: 0.5rem 0;
          }

          .quick-stats {
            justify-content: center;
            padding-top: 1rem;
            margin-top: 1rem;
          }

          .image-container {
            width: 280px;
            height: 280px;
            margin-bottom: 1.5rem;
            margin-left: auto;
            margin-right: auto;
          }
        }

        /* Mobile Small */
        @media (max-width: 575.98px) {
          .hero-section {
            padding: 1rem 0 1.5rem 0;
            min-height: 40vh;
            max-height: 75vh;
          }

          .hero-title {
            font-size: 1.4rem;
            margin-top: 0.5rem;
            margin-bottom: 0.4rem;
            margin-right: 0;
            margin-left: 0;
          }

          .hero-specialty-wrap {
            margin-bottom: 0.65rem;
          }

          .hero-specialty {
            padding: 0.28rem 0.65rem;
            font-size: 0.74rem;
          }

          .hero-subtitle {
            font-size: 0.8rem;
            margin-bottom: 0.8rem;
            max-width: 280px;
            line-height: 1.3;
            margin-right: auto;
            margin-left: auto;
            text-align: center !important;
          }

          .professional-badge {
            margin-bottom: 0.6rem;
            font-size: 0.75rem;
            padding: 0.3rem 0.7rem;
          }

          .hero-actions {
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;
            gap: 0.5rem;
            margin: 0 auto 0.8rem;
          }

          .hero-btn {
            padding: 0.5rem 1rem;
            font-size: 0.75rem;
            min-width: 120px;
          }

          .quick-stats {
            flex-direction: row;
            justify-content: space-around;
            gap: 0.5rem;
            padding: 0.6rem 1rem;
            margin-top: 0.6rem;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 8px;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
          }

          .stat-item {
            align-items: center;
            text-align: center;
          }

          .stat-number {
            font-size: 0.9rem;
          }

          .stat-label {
            font-size: 0.65rem;
            margin-top: 0.1rem;
          }

          .image-container {
            width: 210px;
            height: 210px;
            margin-bottom: 0.8rem;
            border-radius: 6px;
            margin-left: auto;
            margin-right: auto;
          }

          .hero-image-section {
            padding: 0.3rem;
          }

          .hero-content {
            padding: 0;
          }
        }

        /* Extra Small Mobile */
        @media (max-width: 415px) {
          .hero-section {
            padding: 0.8rem 0 1.2rem 0;
            min-height: 40vh;
            max-height: 70vh;
          }

          .hero-title {
            font-size: 1.2rem;
          }

          .hero-subtitle {
            font-size: 0.75rem;
            max-width: 250px;
          }

          .hero-btn {
            padding: 0.4rem 0.8rem;
            font-size: 0.7rem;
            min-width: 110px;
          }

          .image-container {
            width: 200px;
            height: 200px;
            margin-left: auto;
            margin-right: auto;
          }

          .stat-number {
            font-size: 0.9rem;
          }

          .stat-label {
            font-size: 0.6rem;
          }
        }

        @media (max-width: 380px) {
          .hero-section {
            padding: 0.8rem 0 1.2rem 0;
            min-height: 40vh;
            max-height: 75vh;
          }

          .image-container {
            width: 140px;
            height: 140px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      `}</style>
    </section>
  );
};

export default HomeHeroSection;
